import moment from 'moment';

export const invoiceFixBidConfig = {
  api: () => '/FixBidiInvoice',
  title: 'Invoice Jobs',
  extraCall: (id) => '/FixBidiInvoice/send/mail/' + id,
  isActionTab: true,
  moreActions: [
    {
      name: 'View PDF',
      action: 'invoice',
      getKey: (value) => value.invoiceFile,
    },
  ],
  maskClosable: false,
  modalTitle: (action) => action + ' Invoice',
  getColumns: () => {
    return [
      {
        title: 'Invoice Number',
        dataIndex: 'invoiceNumber',
        key: 'invoiceNumber',
        render: (value) => {
          return `A-${value}`;
        },
      },
      {
        title: 'Bill From',
        dataIndex: 'billFrom',
        key: 'billFrom',
        render: (value) => {
          return `${value.ifscNumber} - ${value.beneficiaryName} `;
        },
      },
      {
        title: 'Bill TO',
        dataIndex: 'billTo',
        key: 'billTo',
        render: (value) => {
          return `${value.name} (${value.clientName})`;
        },
      },
      {
        title: 'Billing Start Date',
        dataIndex: 'startDate',
        key: 'startDate',
        render: (value) => {
          return moment(value).format('DD MMM, YYYY');
        },
      },
      {
        title: 'Billing End Date',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (value) => {
          return moment(value).format('DD MMM, YYYY');
        },
      },
      {
        title: 'Is PDF Genrated',
        dataIndex: 'invoiceGenrated',
        key: 'invoiceGenrated',
        render: (value) => {
          return value ? 'Done' : 'In-Progress';
        },
      },
      {
        title: 'Invoice Sent On',
        dataIndex: 'invoiceClearedAt',
        key: 'invoiceClearedAt',
        render: (value) => {
          return value ? moment(value).format('DD MMM, YYYY') : 'Waiting';
        },
      },

      {
        title: 'Is Invoice Sent',
        dataIndex: 'invoiceSent',
        key: 'invoiceSent',
        render: (value) => {
          return value ? 'Sent' : 'Pending';
        },
      },
      {
        title: 'Is Cleared',
        dataIndex: 'invoiceCleared',
        key: 'invoiceCleared',
        render: (value) => {
          return value ? 'Done' : 'Pending';
        },
      },
      {
        title: 'Cleared On',
        dataIndex: 'invoiceClearedAt',
        key: 'invoiceClearedAt',
        render: (value) => {
          return value ? moment(value).format('DD MMM, YYYY') : 'Waiting';
        },
      },
    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'Bill From',
        dataIndex: 'billFrom',
        key: 'billFrom',
        type: 'select',
        isCombo: true,
        isRequired: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Bill To',
        dataIndex: 'billTo',
        key: 'billTo',
        type: 'select',
        isCombo: true,
        isRequired: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Milestone',
        dataIndex: 'milestones',
        key: 'milestones',
        type: 'form',
        heading: 'Milestones',
        form: [
          [
            {
              title: 'Milestone',
              dataIndex: 'milestone',
              key: 'milestone',
              type: 'text',
              multiple: false,
              isCombo: false,
              formClassName: 'col-4 pb-2',
            },
            {
              title: 'Price',
              dataIndex: 'price',
              key: 'price',
              type: 'number',
              isRequired: true,
              formClassName: 'col-4 pb-2',
            },
          ],
        ],
      },
      {
        title: 'TDS',
        dataIndex: 'tds',
        isRequired: true,
        lebelInstructions: 'Value will be count as percentage(%)',
        key: 'tds',
        type: 'number',
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'GST',
        dataIndex: 'GST',
        isRequired: true,
        lebelInstructions: 'Value will be count as percentage(%)',
        key: 'GST',
        type: 'number',
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Start Date',
        dataIndex: 'startDate',
        key: 'startDate',
        isRequired: true,
        type: 'date',
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'End Date',
        dataIndex: 'endDate',
        key: 'endDate',
        type: 'date',
        isRequired: true,
        formClassName: 'col-4 pb-2',
      },
      // {
      //   title: 'Is Billing for Working days?',
      //   dataIndex: 'countAsWorkingDays',
      //   key: 'countAsWorkingDays',
      //   type: 'checkbox',
      //   formClassName: 'col-6 pb-',
      // },
      {
        title: 'Email Template',
        dataIndex: 'emailTemplate',
        key: 'emailTemplate',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
    ];
  },
  combo: [
    {
      name: 'emailTemplate',
      api: '/cms/emailTemplates',
      idKey: '_id',
      nameKey: ['name'],
    },
    {
      name: 'billTo',
      api: '/projects',
      idKey: '_id',
      nameKey: ['name', 'clientName'],
    },
    {
      name: 'billFrom',
      api: '/accounts',
      idKey: '_id',
      nameKey: ['beneficiaryName', 'ifscNumber'],
    },
    {
      name: 'developers',
      api: '/users/developers/list',
      idKey: '_id',
      nameKey: ['firstName', 'middelName', 'lastName'],
    },
  ],
  getData: () => ({}),
  actions: [
    { name: 'Search', isFilter: true, date: true },
    { name: 'Add InvoiceJob', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
